import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import Button from "../../components/button";
import InputForm from "../../components/input-form";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";

import {FaPlusSquare} from "react-icons/fa";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"
import {useQuery} from "@tanstack/react-query";
import resalesService from "../../services/resales-service";
import {useNavigate} from "react-router-dom";
import phoneRender from "../dashboard/components/phone-render";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";

const Resales = () => {
    const navigate = useNavigate();

    const {data: resales} = useQuery({
        queryFn: () => resalesService.list().then(({data}) => data),
        queryKey: ['resales']
    });

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const [columnDefs] = useState([
        { field: "id", headerName: "Id", width: 40 },
        { field: "name", headerName: "Nome", flex: 1, minWidth: 200 },
        { field: "phone", headerName: "Telefone", cellRenderer: phoneRender, flex: 1, minWidth: 200 },
        { field: "contact", headerName: "Contato", flex: 1, minWidth: 200 }
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => {
        return buildAccentInsensitiveColDef({resizable: false});
    }, []);

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setAccentInsensitiveQuickFilter(gridRef, target.value);
    }, []);

    const onCellClicked = (cell) => {
        if (cell.colDef.field !== "phone") navigate(`/resales/form/${cell.data.id}`)
    };

    return (
        <TemplateDefault title="Revendas">
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <Button col="col-span-2" onClick={() => navigate("/resales/form")}>
                        <FaPlusSquare/> Nova revenda
                    </Button>

                    <InputForm id="search" col="col-span-10" label="Pesquisar" type="search" onChange={onFilterTextBoxChanged}/>
                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{height: "calc(100vh - 185px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={resales}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[20, 50, 100, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        onCellClicked={onCellClicked}
                        gridOptions={{localeText: LocalizationAgGrid}}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default Resales;
